// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"t6","tile":"t7","imageWrapper":"t8","img":"t9","header":"t-","caption":"t_"};